module.exports = __webpack_public_path__ + "static/media/EE.2aac86c8.svg";